import { inject } from '@angular/core';
import { SplashScreenStateService } from '../common/services/splash-screen-state.service';
import { ConfigService } from '../config/services/config.service';
import { Router } from '@angular/router';

export const InfoPageGuard = () => {
    const router = inject(Router);
    const splashScreenStateService = inject(SplashScreenStateService);
    const configService = inject(ConfigService);

    if (configService.config()?.configuration?.features?.infoPage?.enabled) {
        splashScreenStateService.stop();
        return true;
    } else {
        return router.navigate(['/']);
    }
};
